import { render, staticRenderFns } from "./CategoriesTree.vue?vue&type=template&id=5339cc2f&scoped=true&"
import script from "./CategoriesTree.vue?vue&type=script&lang=js&"
export * from "./CategoriesTree.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesTree.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CategoriesTree.vue?vue&type=style&index=1&id=5339cc2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5339cc2f",
  null
  
)

export default component.exports